module.exports = __webpack_public_path__ + "static/media/step-card-inactive.4965a3f9.svg";